import Server from "../server";
import View from "../framework/view";
import {OptionSelected, Order} from "../bo/order";
import template from "../../pugc/add-order";
import {formToJson, parseDate} from "../misc/utils";
import {PaymentElementView} from "./payment_element";
import jQuery from "jquery";
import {App} from "../app/app";
import {addressToString, isDelivery} from "../misc/orders";
import {parseISO} from "date-fns";
import {autocomplete} from "../google/autocomplete";
import PlaceResult = google.maps.places.PlaceResult;
import {ExtrasModel, ExtrasView} from "./extras";
import {getExtrasAvailable} from "../bo/extras";
import {Inventory} from "../bo/inventory";

const DEFAULT_DELIVERY_PRICE = 20;

export class AddOrderView extends View {

    static classname = "add-order-view";

    private readonly server = Server.instance();

    private app: App;

    private place?: PlaceResult;

    private addressValidated : boolean | undefined = undefined;

    private paymentElementView = new PaymentElementView()

    private totalprice: number | undefined;

    private pricerows: { name: string, price: number }[] = [];

    private serialize_counter = 0;

    private allInventory: Inventory[] = [];
    private inventory: Inventory[] = [];

    private inventoryUse: { [key: string]: number} = {};

    private expandInventoryUse = false;

    private extrasModel: ExtrasModel = {
        extrasAvailable: [],
        currentExtras: undefined,
        addedExtras: [],
        onChange: () => {
            this.updatePrice();
            this.update(".addons");
        },
    };

    private extras = new ExtrasView(this.extrasModel);

    constructor(app: App) {
        super(AddOrderView.classname);
        this.app = app;
        this.listenForPayment();

        this.init();
    }

    async init () {
        const allExtras = await getExtrasAvailable();
        this.extrasModel.extrasAvailable = allExtras;

        const inv = await this.server.getInventory();
        this.allInventory = inv.filter(i => i.status == "Available");

        this.update();
    }

    private listenForPayment() {
        const paid_ = this.paymentElementView.getPromise();
        paid_.then(() => {
            this.addOrder({paid: true});
        });
        paid_.catch(() => {
            this.paymentElementView.newPromise();
            this.listenForPayment();
        });
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            paymentElementView: this.paymentElementView,
            // addons: ADDONS,
            extras: this.extras,
            totalprice: this.totalprice,
            pricerows: this.pricerows,
            inventory: this.inventory,
            inventoryUse: this.inventoryUse,
            expandInventoryUse: this.expandInventoryUse,
        };

        const out = this.pug(template, data);

        this.initElt(() => {

            this.elt().find("input.datefield").datefield({startDay: 1});
            this.configDeliveryForm(false);

            const line1 = this.elt().find("input[name='shippingInfo.shipmentDetails.address.addressLine1']");

            const updateAddressValidated = () => {
                line1.toggleClass("address-good", this.addressValidated === true);
                line1.toggleClass("address-bad", this.addressValidated === false);
                line1.toggleClass("address-pending", this.addressValidated === undefined);
            };

            line1.on("input", () => {
                this.elt().find(".autocompleted").text("");
                this.place = undefined;
                this.addressValidated = undefined;
                updateAddressValidated();
            });
            line1.on("blur", () => {
                this.addressValidated = this.place !== undefined;
                updateAddressValidated();
            });

            autocomplete(line1[0] as HTMLInputElement).then((autocomplete) => {
                autocomplete.addListener("place_changed", () => {
                    this.place = autocomplete.getPlace();
                    this.addressValidated = this.place !== undefined;
                    console.log("Place changed", this.place);
                    const order = this.toOrder();
                    const address = isDelivery(order);
                    const autocompleted = (address && address.addressLine1) || "";
                    this.elt().find(".autocompleted").text(autocompleted);

                    updateAddressValidated();
                    this.updatePrice();
                });
            });

        });

        return out;
    }

    configDeliveryForm(enabled: boolean) {
        this.elt().find(".shippingInfo .delivery input").prop("disabled", ! enabled);
        this.elt().find(".shippingInfo .delivery").css({opacity: enabled ? 1 : 0.25});
        this.updateInventory();
    }

    updateInventory() {
        const isDelivery = this.elt().find("input[name='delivery']").is(":checked");

        // dd/mm/yyyy
        const d = this.elt().find("input[name='lineItems.0.customTextFields.1.value']").val() as string;
        const deliveryDate = parseDate(d);

        this.inventory = this.allInventory.filter(inv => {
            if (isDelivery && ! inv.forDelivery) {
                return false;
            }
            if (! isDelivery && ! inv.forPickup) {
                return false;
            }
            if (! deliveryDate) {
                return false;
            }
            if ((inv.fromDate && deliveryDate < inv.fromDate) || (inv.toDate && deliveryDate > inv.toDate)) {
                return false;
            }
            return true;
        });

        this.update(".inventory");
    }

    toOrder() : Order {
        const form = this.elt().find("form.add-order-form");
        const data : any = {};
        formToJson(form, data);

        const order : Order = {};
        const options: OptionSelected[] = [];
        for (const key of Object.keys(data)) {

            if (data[key] === "" && key.indexOf("shippingInfo") > -1) {
                continue;
            }

            const bits = key.split(/\./);

            let target : any = order;
            for (let i = 0; i < bits.length; i++) {
                const bit = bits[i];
                if (i == bits.length - 1) {
                    target[bit] = data[key];
                    break;
                }

                if (target[bit] === undefined) {
                    if (isNaN(Number(bits[i+1]))) {
                        target[bit] = {};
                    } else {
                        target[bit] = [];
                    }
                }

                target = target[bit];
            }
        }

        for (const extra of this.extrasModel.addedExtras) {

            let desc = extra.description as string;
            let opt = extra.optionName;
            if (desc.toLowerCase().indexOf(opt.toLowerCase()) == -1) {
                desc = `${opt}: ${desc}`;
            }
            const option = {
                option: extra.optionName,
                price: extra.value,
                selection: extra.description
            };
            options.push(option);
        }

        if (options.length > 0) {
            // @ts-ignore
            order.lineItems[0].options = options;
        }

        const description = order.lineItems && order.lineItems[0] && order.lineItems[0].name as string;
        const dollars = extractLineItemPrice(order);
        if (order.lineItems && order.lineItems[0]) {
            order.lineItems[0].name += " $" + dollars;
        }

        const address = isDelivery(order);
        if (address) {
            if (! address.country) {
                address.country = "AU";
            }
            if (address.addressLine1) {
                address.addressLine1 = address.addressLine1.replace(/, Australia$/, "");
            }
            if (this.place?.geometry?.location) {
                address.lat = this.place.geometry.location.lat();
                address.lng = this.place.geometry.location.lng();
                address.geocoded = true;
            }
        }

        const times = [];
        if (order.deliveryAfter) {
            times.push("after " + order.deliveryAfter);
        }
        if (order.deliveryBefore) {
            times.push("before " + order.deliveryBefore);
        }
        if (times.length > 0) {
            // @ts-ignore
            const c = order.lineItems[0].customTextFields || [];
            const fields = c.filter((f: any) => f.title.indexOf("Pick up or delivery date") == 0);
            if (fields.length != 0) {
                fields[0].value += " " + times.join(", ");
            }
        }

        order.totals = {
            total: (this.totalprice || 0) as any as string
        }

        return order;
    }

    addOrder(params: {paid?: boolean, toPay?: boolean}) {
        const order = this.toOrder();
        if (params.paid) {
            order.orderHistory = [
                {
                    createdTs: new Date().getTime(),
                    newStatus: "Paid",
                    createdBy: "Stripe"
                }
            ];
        }
        if (params.toPay) {
            order.orderHistory = [
                {
                    createdTs: new Date().getTime(),
                    newStatus: "To pay"
                }
            ];
        }

        const deliveryDate = this.elt().find("input.deliveryDate").val() as string;
        if (deliveryDate) {
            try {
                const d = parseDate(deliveryDate as string);
                const z = d && parseISO(d);
                if (d && z) {
                    order.deliveryDate = d;
                }
            } catch (err) {
                // Ignore, delivery date can be set manually.
            }
        }

        const add_ = this.server.addOrder(order);
        add_.then(() => {
            this.app.gotoUrl("/orders/new")
        });
    }

    takePayment() {
        const order = this.toOrder();

        this.calcPrice();

        let dollars = this.totalprice;

        if (dollars === undefined) {
            return;
        }

        let description = order.lineItems && order.lineItems[0] && order.lineItems[0].name as string;

        const cents = parseInt("" + (dollars * 100));
        dollars = cents / 100;

        const intent_ = this.paymentElementView.createIntent(dollars, description);

        intent_.then(() => {
            const pelt = this.paymentElementView.elt();
            const offset = pelt && pelt.offset();
            if (offset) {
                jQuery("html, body").animate({
                    scrollTop: offset.top
                }, 100);
            }
        });
    }

    async calcPrice() {
        const order = this.toOrder();
        const price = order.lineItems && order.lineItems[0] && order.lineItems[0].price;

        let deliveryRow : { name: string, price: number } | undefined = undefined;

        const deliveryAddress = isDelivery(order);
        if (deliveryAddress) {

            const addressString = addressToString(deliveryAddress);

            const cnt = ++this.serialize_counter;

            const cost = await this.server.getDeliveryCost(addressString);

            if (cnt !== this.serialize_counter) {
                return; // Address must have changed, don't overwrite later results
            }

            const delivery_price = cost.ok ? cost.cost as number : (cost.minCost ? cost.minCost as number : DEFAULT_DELIVERY_PRICE);
            const name = cost.ok ? cost.msg as string : "Default delivery price";

            deliveryRow = {name: name, price: delivery_price};
        }

        this.totalprice = Number(price);
        this.pricerows = [];

        if (! this.totalprice) {
            return;
        }

        this.pricerows.push({name: "Order", price: this.totalprice});

        if (deliveryRow) {
            this.totalprice += deliveryRow.price;
            this.pricerows.push(deliveryRow);
        }

        // @ts-ignore
        const options = order.lineItems[0].options || [];

        for (const option of options) {
            // @ts-ignore
            this.pricerows.push({name: option.option, price: option.price});
            // @ts-ignore
            this.totalprice += Number(option.price);
        }

        console.log("calc", this.totalprice, this.pricerows);
    }

    configPaymentButton() {
        this.calcPrice();
        const price = this.totalprice;
        this.elt().find(".take-payment").prop("disabled", !price);
    }

    copyBuyerName() {
        const f = (from: string, to: string) => {
            const val = this.elt().find("input[name='" + from + "']").val();
            if (val) {
                this.elt().find("input[name='" + to + "']").val(val);
            }
        };

        f("buyerInfo.firstName", "shippingInfo.shipmentDetails.address.fullName.firstName");
        f("buyerInfo.lastName", "shippingInfo.shipmentDetails.address.fullName.lastName");
    }
    copyBuyerPhone() {
        const f = (from: string, to: string) => {
            const val = this.elt().find("input[name='" + from + "']").val();
            if (val) {
                this.elt().find("input[name='" + to + "']").val(val);
            }
        };

        f("buyerInfo.phone", "shippingInfo.shipmentDetails.address.phone");
    }


    async updatePrice() {
        await this.calcPrice();
        this.update(".totalprice");
    }

    rememberInventoryUse(name: string, qty: number) {
        this.inventoryUse[name] = qty;
    }

    setExpandInventoryUse() {
        this.expandInventoryUse = true;
        this.update(".inventory");
    }
}

function extractLineItemPrice(order: Order) {
    const price = order.lineItems && order.lineItems[0] && order.lineItems[0].price;
    let dollars = Number.parseFloat(price as any as string);
    return dollars;
}

View.on(
    "." + AddOrderView.classname,
    "click",
    ".add-order",
    function(that: AddOrderView, event, elt) {
        event.preventDefault();
        const toPay = jQuery(elt).data("topay") ? true : false;
        that.addOrder({toPay: toPay});
    });

View.on(
    "." + AddOrderView.classname,
    "click",
    ".take-payment",
    function(that: AddOrderView, event, elt) {
        event.preventDefault();
        that.takePayment();
    });

View.on(
    "." + AddOrderView.classname,
    "change",
    "input[name='lineItems.0.price']",
    function(that: AddOrderView, event, elt) {
        event.preventDefault();
        that.configPaymentButton();
    });

View.on(
    "." + AddOrderView.classname,
    "click",
    ".copy-buyer-name",
    function(that: AddOrderView, event, elt) {
        event.preventDefault();
        that.copyBuyerName();
    });

View.on(
    "." + AddOrderView.classname,
    "click",
    ".copy-buyer-phone",
    function(that: AddOrderView, event, elt) {
        event.preventDefault();
        that.copyBuyerPhone();
    });

View.on(
    "." + AddOrderView.classname,
    "change",
    "input[name='delivery']",
    function(that: AddOrderView, event, elt) {
        const delivery = jQuery(elt).is(":checked");
        that.configDeliveryForm(delivery);
    });

View.on(
    "." + AddOrderView.classname,
    "change",
    ".addons input, input[name='delivery'], .delivery input, input[name='lineItems.0.price']",
    function(that: AddOrderView, event, elt) {
        that.updatePrice();
    });
View.on(
    "." + AddOrderView.classname,
    "click",
    ".modal-background",
    function(that: AddOrderView, event, elt) {
        jQuery(elt).closest(".modal.show").removeClass("show");
    });
View.on(
    "." + AddOrderView.classname,
    "click",
    ".close",
    function(that: AddOrderView, event, elt) {
        jQuery(elt).closest(".modal.show").removeClass("show");
    });
View.on(
    "." + AddOrderView.classname,
    "change",
    ".deliveryDate",
    function(that: AddOrderView, event, elt) {
        that.updateInventory();
    });

View.on(
    "." + AddOrderView.classname,
    "change",
    ".inventory-use-input",
    function(that: AddOrderView, event, elt) {
        const val = jQuery(elt).val() as number;
        const name = jQuery(elt).data("name") as string;
        that.rememberInventoryUse(name, val);
    });

View.on(
    "." + AddOrderView.classname,
    "click",
    ".expand-inventory",
    function(that: AddOrderView, event, elt) {
        event.preventDefault();
        that.setExpandInventoryUse();
    });

